import http, { HttpBodyUnpacking } from '@/lib/request.js'

import * as container from '@/lib/container.js'
import * as detective from '@/lib/detective.js'
import * as structure from '@/lib/structure.js'

import * as work_model from '@/model/work.js'
import * as company_model from '@/model/company.js'

import * as contract from './contract.js'




export type TRawDocumentType = Required<company_model.THydratedDocumentType>

export type THydratedDocumentType = structure.Overwrite<
	Required<company_model.THydratedDocumentType>,

	Required<company_model.TVirtuals>

>

export type TContractHydratedDocumentType = structure.Overwrite<
	contract.THydratedDocumentType<'user' | 'archive'>,

	{ company: string }

>


export function query (): HttpBodyUnpacking<string>
{
	return http.options('/company')

}


export function create
(
	data: {
		_id: string

		compact: string

		name     : string
		league?  : string
		introduce: string

	},

)
:	HttpBodyUnpacking<string>
{
	return http.post('/company', data)

}

export function create_work
(
	_id: string,

	data: {
		name  : string
		office: string

		location?: detective.Range<number>


	},

)
:	HttpBodyUnpacking<string>
{
	return http.post(`/company/${_id}/work`, data)

}


export function update
(
	_id: string,

	data: {
		compact?: string

		name?     : string
		league?   : string
		introduce?: string

	},

)
:	HttpBodyUnpacking<void>
{
	return http.put(`/company/${_id}`, data)

}


export function retrieve
(_id: string): HttpBodyUnpacking<TRawDocumentType>
{
	return http.get(`/company/${_id}`)

}

export function retrieves
(
	params: container.PagerParams<
		{
			keyword?: string

			league? : string

		}

	>,

)
:	HttpBodyUnpacking<THydratedDocumentType[]>
{
	return http.get('/companies', { params })

}

export function retrieve_contracts
(
	_id: string,

	params: container.PagerParams<
		{
			keyword?: string

			begin? : null | detective.Between<Date>
			finish?: null | detective.Between<Date>

			resigned?: null | detective.Between<Date>

			sign?      : string
			settle?    : string
			office?    : string
			insurance? : string
			enrollment?: Date

			example?: boolean

			created?: null | detective.Between<Date>

		}

	>,

)
:	HttpBodyUnpacking<TContractHydratedDocumentType[]>
{
	return http.get(`/company/${_id}/contracts`, { params })

}

export function retrieve_works
(_id: string, params: container.PagerParams): HttpBodyUnpacking<work_model.THydratedDocumentType[]>
{
	return http.get(`/company/${_id}/works`, { params })

}


export function delete_
(_id: string): HttpBodyUnpacking<void>
{
	return http.delete(`/company/${_id}`)

}
